import { useDeviceType, useWLOrgConfigContext } from '@talos/kyoko';

export const useShouldRenderMobile = () => {
  const { config } = useWLOrgConfigContext();
  const isMobile = useDeviceType() === 'mobile' && !!config.allowMobile;
  return isMobile;
};
